// extracted by mini-css-extract-plugin
module.exports = {"favouriteIcon":"product-actions-bar-view-favouriteicon_favouriteIcon__xWZnx"};